import React from 'react';

const WaveNanoIcon = (): React.ReactElement => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="device-svg-icons"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 6C19.0476 6 15 10.0722 15 15.1364V32.8636C15 37.9278 19.0476 42 24 42C28.9524 42 33 37.9278 33 32.8636V15.1364C33 10.0722 28.9524 6 24 6ZM12 15.1364C12 8.45194 17.3544 3 24 3C30.6456 3 36 8.45194 36 15.1364V32.8636C36 39.5481 30.6456 45 24 45C17.3544 45 12 39.5481 12 32.8636V15.1364Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 33C18 29.6863 20.6863 27 24 27C27.3137 27 30 29.6863 30 33C30 36.3137 27.3137 39 24 39C20.6863 39 18 36.3137 18 33ZM24 30C22.3431 30 21 31.3431 21 33C21 34.6569 22.3431 36 24 36C25.6569 36 27 34.6569 27 33C27 31.3431 25.6569 30 24 30Z"
        />
    </svg>
);

export default WaveNanoIcon;
